import { INews } from '../types';
import { renderDate } from './PromotionsNews.utils';

const PromotionsNews = ({ news }: { news: INews[] }) => {
  return (
    <div className="tw-mt-7.5">
      <h2 className="tw-mb-5 tw-text-[32px]/[28px] tw-uppercase tw-text-white lg:tw-mb-10 lg:tw-text-5xl">News</h2>
      {news.map(({ order, title, description, image, read_time, redirect_url, date }, idx) => (
        <a key={order} rel="noreferrer" target="_blank" href={redirect_url}>
          <div className="tw-group tw-relative tw-flex tw-flex-col tw-gap-6 tw-py-7.5 hover:tw-cursor-pointer md:tw-flex-row">
            {idx !== 0 && <div className="tw-absolute tw-inset-x-0 tw-top-0 tw-h-px tw-bg-backgroundColorLight" />}
            <img
              className="tw-h-fit tw-w-[144px] tw-rounded-2xl tw-transition-transform group-hover:[transform:translateY(-10px)]"
              src={image}
              alt={title}
            />
            <div className="tw-flex tw-flex-col tw-gap-y-4 tw-text-white">
              <h4 className="tw-text-3xl tw-font-semibold tw-text-inherit">{title}</h4>
              <p className="tw-line-clamp-3 tw-min-h-[84px] tw-text-xl">{description}</p>
              <div className="tw-text-lg tw-text-skyBlue">
                {read_time} min read<span className="tw-mx-2 tw-text-turquoise">•</span>
                {renderDate(date)}
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default PromotionsNews;
